import React from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import '../styles/AccountsDashboard.css';

ChartJS.register(ArcElement, Tooltip, Legend);

const AccountsDashboard = () => {
  // Doughnut Chart Data for Balance Sheet Summary
  const doughnutData = {
    labels: ['Assets', 'Liabilities', 'Equity', 'Income - Expenses'],
    datasets: [{
      data: [1875430, 640250, 1235180, 635180],
      backgroundColor: ['#3b82f6', '#ef4444', '#22c55e', '#f59e0b'],
      borderWidth: 0,
      cutout: '72%',
    }],
  };

  const donutOptions = {
    plugins: { legend: { display: false }, tooltip: { enabled: true } },
    maintainAspectRatio: false,
  };

  // Mock Data Table for Chart of Accounts
  const accountsData = [
    { id: 1, name: "Cash in Hand", code: "1001", group: "Cash & Bank", type: "Asset", balance: "₹1,25,430.00", status: "Active" },
    { id: 2, name: "HDFC Bank A/c", code: "1002", group: "Cash & Bank", type: "Asset", balance: "₹4,85,250.00", status: "Active" },
    { id: 3, name: "SBI Current A/c", code: "1003", group: "Cash & Bank", type: "Asset", balance: "₹3,75,600.00", status: "Active" },
    { id: 4, name: "Accounts Receivable", code: "1101", group: "Sundry Debtors", type: "Asset", balance: "₹2,45,750.00", status: "Active" },
    { id: 5, name: "Inventory Stock", code: "1201", group: "Inventory", type: "Asset", balance: "₹6,43,400.00", status: "Active" },
    { id: 6, name: "Furniture & Fixtures", code: "1301", group: "Fixed Assets", type: "Asset", balance: "₹1,20,000.00", status: "Active" },
    { id: 7, name: "Accounts Payable", code: "2001", group: "Sundry Creditors", type: "Liability", balance: "₹2,80,600.00", status: "Active" },
    { id: 8, name: "Loan from Bank", code: "2101", group: "Loans (Liability)", type: "Liability", balance: "₹3,25,000.00", status: "Active" },
    { id: 9, name: "Capital Account", code: "3001", group: "Capital", type: "Equity", balance: "₹10,00,000.00", status: "Active" },
    { id: 10, name: "Sales Account", code: "4001", group: "Income", type: "Income", balance: "₹25,60,450.00", status: "Active" },
    { id: 11, name: "Purchase Account", code: "5001", group: "Expenses", type: "Expense", balance: "₹10,85,700.00", status: "Active" },
    { id: 12, name: "Rent Expense", code: "5101", group: "Expenses", type: "Expense", balance: "₹1,25,300.00", status: "Active" }
  ];

  const recentTransactions = [
    { date: "20 May 2025", desc: "Payment from Acme Corp", sub: "Received in HDFC Bank A/c", amount: "+ ₹45,000.00", isPos: true },
    { date: "19 May 2025", desc: "Payment to Galaxy Suppliers", sub: "Paid from SBI Current A/c", amount: "- ₹28,500.00", isPos: false },
    { date: "18 May 2025", desc: "Cash Sale", sub: "Cash in Hand", amount: "+ ₹12,750.00", isPos: true },
    { date: "17 May 2025", desc: "Rent Paid", sub: "Paid from HDFC Bank A/c", amount: "- ₹15,000.00", isPos: false },
    { date: "16 May 2025", desc: "Purchase from Green Mart", sub: "Added to Accounts Payable", amount: "- ₹22,300.00", isPos: false }
  ];

  return (
    <div className="acc-wrapper">
      
      {/* KPI Grid */}
      <div className="acc-kpi-grid">
        <div className="acc-card acc-kpi-card">
          <div className="acc-kpi-header">
            <div className="acc-icon-box acc-bg-blue-light"><i className="fa-solid fa-wallet acc-text-blue"></i></div>
            <div className="acc-kpi-info">
              <span className="acc-kpi-title">Total Assets</span>
              <h2 className="acc-kpi-value">₹18,75,430.00</h2>
              <div className="acc-kpi-meta">
                <span>All Assets</span>
                <span className="acc-trend-green"><i className="fa-solid fa-arrow-up"></i> 12.5%</span>
              </div>
            </div>
          </div>
        </div>
        
        <div className="acc-card acc-kpi-card">
          <div className="acc-kpi-header">
            <div className="acc-icon-box acc-bg-purple-light"><i className="fa-solid fa-file-invoice acc-text-purple"></i></div>
            <div className="acc-kpi-info">
              <span className="acc-kpi-title">Total Liabilities</span>
              <h2 className="acc-kpi-value">₹6,40,250.00</h2>
              <div className="acc-kpi-meta">
                <span>All Liabilities</span>
                <span className="acc-trend-red"><i className="fa-solid fa-arrow-up"></i> 8.3%</span>
              </div>
            </div>
          </div>
        </div>

        <div className="acc-card acc-kpi-card">
          <div className="acc-kpi-header">
            <div className="acc-icon-box acc-bg-orange-light"><i className="fa-solid fa-hand-holding-dollar acc-text-orange"></i></div>
            <div className="acc-kpi-info">
              <span className="acc-kpi-title">Total Equity</span>
              <h2 className="acc-kpi-value">₹12,35,180.00</h2>
              <div className="acc-kpi-meta">
                <span>Capital & Reserves</span>
                <span className="acc-trend-green"><i className="fa-solid fa-arrow-up"></i> 10.2%</span>
              </div>
            </div>
          </div>
        </div>

        <div className="acc-card acc-kpi-card">
          <div className="acc-kpi-header">
            <div className="acc-icon-box acc-bg-green-light"><i className="fa-solid fa-clock-rotate-left acc-text-green"></i></div>
            <div className="acc-kpi-info">
              <span className="acc-kpi-title">Total Income (This Year)</span>
              <h2 className="acc-kpi-value">₹25,60,450.00</h2>
              <div className="acc-kpi-meta">
                <span>Till Date</span>
                <span className="acc-trend-green"><i className="fa-solid fa-arrow-up"></i> 15.6%</span>
              </div>
            </div>
          </div>
        </div>

        <div className="acc-card acc-kpi-card">
          <div className="acc-kpi-header">
            <div className="acc-icon-box acc-bg-red-light"><i className="fa-solid fa-chart-pie acc-text-red"></i></div>
            <div className="acc-kpi-info">
              <span className="acc-kpi-title">Total Expenses (This Year)</span>
              <h2 className="acc-kpi-value">₹13,25,270.00</h2>
              <div className="acc-kpi-meta">
                <span>Till Date</span>
                <span className="acc-trend-red"><i className="fa-solid fa-arrow-up"></i> 6.7%</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div className="acc-tabs-container">
        <div className="acc-tab active">Chart of Accounts</div>
        <div className="acc-tab">Ledger Accounts</div>
        <div className="acc-tab">Account Groups</div>
      </div>

      {/* Main Layout Grid */}
      <div className="acc-main-layout">
        
        {/* LEFT COLUMN: Main Table */}
        <div className="acc-left-col">
          <div className="acc-card acc-p-24">
            
            {/* Filters Row */}
            <div className="acc-filters-row">
              <div className="acc-search-box">
                <i className="fa-solid fa-magnifying-glass"></i>
                <input type="text" placeholder="Search account name or code..." />
              </div>
              <div className="acc-dropdown">All Groups <i className="fa-solid fa-chevron-down"></i></div>
              <div className="acc-dropdown">All Account Types <i className="fa-solid fa-chevron-down"></i></div>
              <button className="acc-btn-outline"><i className="fa-solid fa-filter"></i> More Filters</button>
            </div>

            {/* Data Table */}
            <div className="acc-table-wrapper">
              <table className="acc-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Account Name</th>
                    <th>Group</th>
                    <th>Type</th>
                    <th className="acc-align-right">Balance (₹)</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {accountsData.map((row) => (
                    <tr key={row.id}>
                      <td className="acc-text-muted acc-fw-500">{row.id}</td>
                      <td>
                        <div className="acc-fw-600">{row.name}</div>
                        <div className="acc-text-muted acc-text-xs">{row.code}</div>
                      </td>
                      <td className="acc-fw-500">{row.group}</td>
                      <td><span className={`acc-badge acc-badge-${row.type.toLowerCase()}`}>{row.type}</span></td>
                      <td className="acc-align-right acc-fw-500">{row.balance}</td>
                      <td><span className="acc-badge acc-badge-active">Active</span></td>
                      <td>
                        <div className="acc-actions-cell">
                          <button className="acc-action-btn"><i className="fa-regular fa-pen-to-square"></i></button>
                          <button className="acc-action-btn"><i className="fa-solid fa-ellipsis-vertical"></i></button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            <div className="acc-pagination">
              <span className="acc-page-info">Showing 1 to 12 of 45 entries</span>
              <div className="acc-page-controls">
                <button className="acc-page-btn"><i className="fa-solid fa-chevron-left"></i></button>
                <button className="acc-page-btn acc-page-active">1</button>
                <button className="acc-page-btn">2</button>
                <button className="acc-page-btn">3</button>
                <button className="acc-page-btn">4</button>
                <button className="acc-page-btn">5</button>
                <span className="acc-page-dots">...</span>
                <button className="acc-page-btn"><i className="fa-solid fa-chevron-right"></i></button>
              </div>
              <div className="acc-page-size">
                Show <select defaultValue="12"><option value="12">12</option></select> per page
              </div>
            </div>

          </div>
        </div>

        {/* RIGHT COLUMN: Sidebar Cards */}
        <div className="acc-right-col">
          
          {/* Balance Sheet Summary */}
          <div className="acc-card acc-p-24">
            <h3 className="acc-card-title">Balance Sheet Summary</h3>
            <div className="acc-card-sub">As on 20 May 2025</div>
            
            <div className="acc-donut-layout">
              <div className="acc-donut-wrapper">
                <Doughnut data={doughnutData} options={donutOptions} />
                <div className="acc-donut-center">
                  <span className="acc-dc-label">Net Worth</span>
                  <strong className="acc-dc-value">₹12,35,180.00</strong>
                </div>
              </div>
              <div className="acc-donut-legend">
                <div className="acc-leg-item">
                  <span className="acc-dot acc-bg-blue"></span>
                  <div className="acc-leg-text"><strong>Assets</strong><span>₹18,75,430.00 (55.6%)</span></div>
                </div>
                <div className="acc-leg-item">
                  <span className="acc-dot acc-bg-red"></span>
                  <div className="acc-leg-text"><strong>Liabilities</strong><span>₹6,40,250.00 (18.9%)</span></div>
                </div>
                <div className="acc-leg-item">
                  <span className="acc-dot acc-bg-green"></span>
                  <div className="acc-leg-text"><strong>Equity</strong><span>₹12,35,180.00 (36.6%)</span></div>
                </div>
                <div className="acc-leg-item">
                  <span className="acc-dot acc-bg-orange"></span>
                  <div className="acc-leg-text"><strong>Income - Expenses</strong><span>₹6,35,180.00 (18.9%)</span></div>
                </div>
              </div>
            </div>
          </div>

          {/* Quick Actions */}
          <div className="acc-card acc-p-24">
            <h3 className="acc-card-title acc-mb-16">Quick Actions</h3>
            <div className="acc-quick-actions-grid">
              <div className="acc-qa-item">
                <div className="acc-icon-md acc-bg-blue-light acc-text-blue"><i className="fa-solid fa-box-archive"></i></div>
                <strong>Add Account</strong>
                <span>Create new account</span>
              </div>
              <div className="acc-qa-item">
                <div className="acc-icon-md acc-bg-purple-light acc-text-purple"><i className="fa-solid fa-users"></i></div>
                <strong>Add Account Group</strong>
                <span>Create group</span>
              </div>
              <div className="acc-qa-item">
                <div className="acc-icon-md acc-bg-green-light acc-text-green"><i className="fa-solid fa-book"></i></div>
                <strong>Ledger Report</strong>
                <span>View ledger</span>
              </div>
              <div className="acc-qa-item">
                <div className="acc-icon-md acc-bg-orange-light acc-text-orange"><i className="fa-solid fa-file-lines"></i></div>
                <strong>Trial Balance</strong>
                <span>View report</span>
              </div>
            </div>
          </div>

          {/* Recent Transactions */}
          <div className="acc-card acc-p-24">
            <div className="acc-card-header">
              <h3 className="acc-card-title">Recent Transactions</h3>
              <a href="#" className="acc-link">View All</a>
            </div>
            <div className="acc-transactions-list">
              {recentTransactions.map((tx, i) => (
                <div className="acc-tx-item" key={i}>
                  <div className="acc-tx-date">{tx.date}</div>
                  <div className="acc-tx-desc">
                    <strong>{tx.desc}</strong>
                    <span>{tx.sub}</span>
                  </div>
                  <div className={`acc-tx-amount ${tx.isPos ? 'acc-text-green' : 'acc-text-red'}`}>
                    {tx.amount}
                  </div>
                </div>
              ))}
            </div>
            <div className="acc-mt-16">
              <a href="#" className="acc-link acc-link-icon">View all transactions <i className="fa-solid fa-arrow-right"></i></a>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default AccountsDashboard;